import { useState } from "react";
import { C } from "../lib/colors";

export const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{background:C.s1,borderRadius:12,marginBottom:8,overflow:"hidden",border:`1px solid ${C.border}`}}>
      <div onClick={()=>setOpen(!open)} style={{padding:"18px 22px",fontWeight:600,fontSize:15,cursor:"pointer",
        display:"flex",justifyContent:"space-between",alignItems:"center",gap:16,userSelect:"none",transition:"background 0.2s"}}
        onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.02)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
        {q}
        <span style={{color:C.green,fontSize:18,transition:"transform 0.3s",transform:open?"rotate(45deg)":"",flexShrink:0}}>+</span>
      </div>
      {open && <div style={{padding:"0 22px 18px",color:C.muted,fontSize:14,lineHeight:1.75,animation:"fadeUp 0.25s ease"}}>{a}</div>}
    </div>
  );
};
